import { Outlet } from 'react-router';

export default function PublicDocsLayout() {
  return <Outlet />;
}
